/**
 * Converts a string to upper case similar to [String#toUpperCase](https://mdn.io/toUpperCase).
 *
 * @example
 * toUpper('foo bar');
 * // => 'FOO BAR'
 *
 * @function toUpper
 * @param {string} str The string to convert.
 * @return {string} Returns the upper cased string.
 */
export default function toUpper(str) {
	if (typeof str !== 'string') return '';

	return str.toUpperCase();
}
